import FilterBox from "@/components/FilterBox.vue";
import { MatchCounts } from "@/lib/evg-shop";
import { getPublicationSlug } from "@/lib/evg-shop-ext";
import { computed, defineComponent, onMounted, onUpdated, reactive, ref, watch } from "vue";
import { Filters, searchModule } from "@/store/search";
import PublicationTable from "@/components/PublicationTable.vue";
import { browseModule } from "@/store/browse";
import { countries } from "@/lib/filters/Countries";
export default defineComponent({
  name: "PublicationByCountry",
  props: {
    countryCode: {
      type: String,
      required: true
    }
  },
  components: {
    FilterBox,
    PublicationTable
  },
  methods: {
    getPublicationSlug: p => getPublicationSlug(p)
  },
  setup(props) {
    const columns = ["aggregate.name", "aggregate.publisherName", "aggregate.scaleName", "matches"].map(p => ({
      prop: p
    }));
    const matchCounts = reactive(new MatchCounts());
    const filters = computed(() => searchModule.filters);
    const countryName = computed(() => countries.find(c => c.code === props.countryCode)?.name);
    const editFilters = ref(new Filters(filters.value));
    const blankFilters = ref(new Filters());
    const hasCounts = computed(() => {
      return matchCounts.publications > 0 || matchCounts.products > 0;
    });
    const updateCounts = () => {
      searchModule.enforceCountry(props.countryCode);
      searchModule.fetchMatchCounts(filters.value).then(c => {
        matchCounts.init(c);
      });
    };
    const updateFilters = newFilters => {
      searchModule.updateFilters(newFilters);
      updateCounts();
    };
    const resetFilter = () => {
      searchModule.resetFilters();
      searchModule.enforceCountry(props.countryCode);
      editFilters.value = new Filters(filters.value);
      updateCounts();
    };
    const onEnter = () => {
      document.title = `Global Explorer - search: ${countryName.value}`;
      blankFilters.value.enforceCountry(props.countryCode);
      browseModule.updateActiveType("");
      updateCounts();
    };
    watch(() => props.countryCode, onEnter);
    watch(() => searchModule.filters, () => editFilters.value.init(searchModule.filters), {
      deep: true
    });
    onMounted(onEnter);
    onUpdated(onEnter);
    return {
      blankFilters,
      columns,
      filters,
      editFilters,
      hasCounts,
      matchCounts,
      countryName,
      updateFilters,
      resetFilter
    };
  }
});